export enum ToastMessageType {
  error = 'danger',
  warning = 'warning',
  success = 'success'
}

export interface ToastMessage {
  message: string,
  title: string,
  type: ToastMessageType,
  delay?: number
}